<cs-card-list>
  <!-- Myo-Reps Section -->
  <cs-card>
    <cs-card-title>
      {{ LL.intake.advanced.myoReps() }}
      <cs-tooltip large iconType="info">
        {{ LL.intake.advanced.myoRepsTooltip() }}
        <help-link helpId="@help:intake.advanced-training-techniques-myo-reps">
          {{ LL.common.buttons.learnMore() }}
        </help-link>
      </cs-tooltip>
    </cs-card-title>
    <cs-card-content>
      <cs-radio-group [(selected)]="state.advancedMethodsMyoReps" (selectedChange)="handleMyoRepsChange()">
        <cs-radio [value]="AdvancedMethodsMyoReps.Prefer">
          {{ LL.intake.advanced.myoRepsPrefer() }}
          <cs-note>{{ LL.intake.advanced.myoRepsPreferNote() }}</cs-note>
        </cs-radio>
        <cs-radio [value]="AdvancedMethodsMyoReps.Avoid">
          {{ LL.intake.advanced.myoRepsAvoid() }}
          <cs-note>{{ LL.intake.advanced.myoRepsAvoidNote() }}</cs-note>
        </cs-radio>
        <cs-radio [value]="AdvancedMethodsMyoReps.Automatic">
          {{ LL.intake.advanced.automatic() }}
          <cs-note>{{ LL.intake.advanced.myoRepsAutomaticNote() }}</cs-note>
        </cs-radio>
      </cs-radio-group>
    </cs-card-content>
  </cs-card>

  <!-- RM Testing Section -->
  <cs-card>
    <cs-card-title>
      {{ LL.intake.advanced.rmTesting() }}
      <cs-tooltip large iconType="info">
        {{ LL.intake.advanced.rmTestingTooltip() }}
        <help-link helpId="@help:intake.advanced-training-techniques-rm-testing">
          {{ LL.common.buttons.learnMore() }}
        </help-link>
      </cs-tooltip>
    </cs-card-title>
    <cs-card-content>
      <cs-radio-group [(selected)]="state.advancedMethodsRMTesting" (selectedChange)="handleRMTestingChange()">
        <cs-radio [value]="AdvancedMethodsRMTesting.Prefer">
          {{ LL.intake.advanced.rmTestingPrefer() }}
          <cs-note>{{ LL.intake.advanced.rmTestingPreferNote() }}</cs-note>
        </cs-radio>
        <cs-radio [value]="AdvancedMethodsRMTesting.Avoid">
          {{ LL.intake.advanced.rmTestingAvoid() }}
          <cs-note>{{ LL.intake.advanced.rmTestingAvoidNote() }}</cs-note>
        </cs-radio>
      </cs-radio-group>
    </cs-card-content>
  </cs-card>
</cs-card-list>